export default () => ({
  illustration: {
    paddingBottom: '46.15%',
    backgroundSize: 'contain',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgba(255, 255, 255, .68)',
  },
  defaultIllustration: {
    backgroundSize: 'cover',
  },
});
